import React from 'react';

import { ReactComponent as RenegociacaoIcon } from '../../../assets/novosicones/Financeiro/handshake_black_24dp.svg';
import { ReactComponent as Extrato } from '../../../assets/novosicones/Financeiro/Extrato.svg';
import { ReactComponent as IRPF } from '../../../assets/novosicones/Financeiro/IRPF.svg';

import './styles.scss';
import TooltipStandard from '../../TooltipStandard';

const Menu = ({
  tema,
  parcelasPagar,
  setParcelasPagar,
  parcelasPagas,
  setParcelasPagas,
  totalParcelasSelecionadas,
  temParcelasAPagar,
  setGerarExtrato,
  setShowRenegociacao,
  gerarExtrato,
  gerarIrrf,
  setGerarIrrf,
  disableMenuBtn,
  disableBtnIrrf,
  aPagar,
  pagas,
  showRenegociacao,
  contratoSelecionado,
  isWithinOperatingPaymentPeriod,
}) => {
  let temaBtnMenuAtivo = {
    backgroundColor: tema.primaryColor,
    border: `2px solid ${tema.primaryColor}`,
    color: '#ffffff',
  };
  let temaBtnMenuDesativado = {
    backgroundColor: 'transparent',
    border: `2px solid ${tema.primaryColor}`,
    color: '#4D4D4D',
  };

  let temaAtual = {
    border: `2px solid ${tema.primaryColor}`,
    color: tema.primaryColor,
  };

  let disableExtrato;

  if (totalParcelasSelecionadas == 0) disableExtrato = false;

  let disableExtratoPorParcelas = false;

  if (aPagar?.length == 0 && pagas?.length == 0)
    disableExtratoPorParcelas = true;

  if (disableMenuBtn || disableExtratoPorParcelas) {
    disableExtrato = true;
  }

  const theme = () => {
    if (disableExtrato || disableMenuBtn) {
      return {
        border: '2px solid #d1d1d1',
        color: '#d1d1d1',
        cursor: 'unset',
      };
    } else if (!disableExtrato && gerarExtrato) {
      return {
        border: `2px solid ${tema.primaryColor}`,
        color: '#ffffff',
        backgroundColor: tema.primaryColor,
      };
    } else {
      return temaAtual;
    }
  };

  const themeBtnIrrf = () => {
    if (gerarIrrf) {
      return {
        border: `2px solid ${tema.primaryColor}`,
        color: '#ffffff',
        backgroundColor: tema.primaryColor,
      };
    } else {
      return temaAtual;
    }
  };

  const themeIcon = () => {
    if (disableExtrato || disableMenuBtn) {
      return { fill: '#d1d1d1', marginRight: '5px' };
    } else if (!disableExtrato && gerarExtrato) {
      return { fill: '#ffffff', marginRight: '5px' };
    } else {
      return { fill: tema.primaryColor, marginRight: '5px' };
    }
  };

  const themeIconIrrf = () => {
    if (disableExtrato || disableMenuBtn || disableBtnIrrf) {
      return { fill: '#d1d1d1', marginRight: '5px' };
    } else if (!disableExtrato && gerarExtrato) {
      return { fill: '#ffffff', marginRight: '5px' };
    } else {
      return { fill: tema.primaryColor, marginRight: '5px' };
    }
  };

  const disableIrrf = () => {
    if (disableExtrato || disableBtnIrrf) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className='centralized-column menu'>
        <div className='centralized-space-between menu__relatorios mobile'>
          <button
            style={
              disableBtnIrrf
                ? {
                    border: '2px solid #d1d1d1',
                    color: '#d1d1d1',
                    cursor: 'unset',
                  }
                : disableMenuBtn
                ? theme()
                : themeBtnIrrf()
            }
            className='centralized'
            onClick={(e) => {
              e.preventDefault();
              setParcelasPagar(false);
              setParcelasPagas(false);
              setGerarExtrato(false);
              setGerarIrrf(true);
              setShowRenegociacao(false);
            }}
            disabled={disableIrrf()}
            id='btnFinanceiroGerarIRRF'
          >
            <IRPF
              style={
                disableMenuBtn || disableBtnIrrf
                  ? themeIconIrrf()
                  : gerarIrrf
                  ? { fill: '#ffffff', marginRight: '5px' }
                  : { fill: tema.primaryColor, marginRight: '5px' }
              }
            />
            Demonstrativo IRRF
          </button>
          <button
            style={theme()}
            className='centralized'
            onClick={(e) => {
              e.preventDefault();
              setParcelasPagar(false);
              setParcelasPagas(false);
              setGerarExtrato(true);
              setGerarIrrf(false);
              setShowRenegociacao(false);
            }}
            disabled={disableExtrato}
            id='btnFinanceiroGerarExtrato'
          >
            <Extrato style={themeIcon()} />
            Gerar extrato
          </button>

          <TooltipStandard
            title={'Horário de funcionamento das 08h00 às 23h50'}
            hide={isWithinOperatingPaymentPeriod}
          >
            <button
              style={
                !contratoSelecionado?.elegivelRenegociacao ||
                !isWithinOperatingPaymentPeriod
                  ? { border: '2px solid #d1d1d1', color: '#d1d1d1' }
                  : showRenegociacao
                  ? temaBtnMenuAtivo
                  : temaAtual
              }
              className='centralized'
              onClick={() => {
                setParcelasPagar(false);
                setParcelasPagas(false);
                setGerarExtrato(false);
                setGerarIrrf(false);
                setShowRenegociacao(true);
              }}
              id='btnFinanceiroRenegociar'
              disabled={
                !contratoSelecionado?.elegivelRenegociacao ||
                !isWithinOperatingPaymentPeriod
              }
            >
              <RenegociacaoIcon
                style={
                  !contratoSelecionado?.elegivelRenegociacao
                    ? { fill: '#d1d1d1', marginRight: '5px' }
                    : showRenegociacao
                    ? { fill: '#ffffff', marginRight: '5px' }
                    : { fill: tema.primaryColor, marginRight: '5px' }
                }
              />
              Renegociar
            </button>
          </TooltipStandard>
        </div>
        {!gerarExtrato && !gerarIrrf && (
          <>
            <div className='menu__parcelas'>
              <button
                style={parcelasPagar ? temaBtnMenuAtivo : temaBtnMenuDesativado}
                onClick={() => {
                  setParcelasPagar(true);
                  setParcelasPagas(false);
                  setGerarExtrato(false);
                  setGerarIrrf(false);
                  setShowRenegociacao(false);
                }}
                id='btnParcelasAPagar'
              >
                Parcelas a pagar
              </button>
              <button
                style={parcelasPagas ? temaBtnMenuAtivo : temaBtnMenuDesativado}
                onClick={() => {
                  setParcelasPagar(false);
                  setParcelasPagas(true);
                  setGerarExtrato(false);
                  setGerarIrrf(false);
                  setShowRenegociacao(false);
                }}
                id='btnParcelasAPagas'
              >
                Parcelas pagas
              </button>
            </div>
            {isWithinOperatingPaymentPeriod &&
              ((parcelasPagar && temParcelasAPagar) || showRenegociacao) && (
                <div className='menu__alertaValorParcelas centralized'>
                  {showRenegociacao ? (
                    <p>
                      Atenção: O valor total reajustado de sua renegociação vai
                      ser apresentado em sua proposta após o início de sua
                      simulação.
                    </p>
                  ) : (
                    <p>
                      Atenção: As parcelas abaixo estão com o valor calculado
                      para pagamento na data atual, as atualizações de valor
                      ocorrem diariamente, conforme seu contrato.
                    </p>
                  )}
                </div>
              )}
          </>
        )}
      </div>
    </>
  );
};

export default Menu;
